// @flow

import * as React from 'react';

import { selectOneProductErrors, type DecoratedProduct } from '@gandi/cart';
import { Fqdn } from '@gandi/ui';

import { useAppSelector } from 'src/hooks';

import ProductItem from './components/ProductItem';

type Props = {
  product: DecoratedProduct,
};

export function DomainChangeOwner({ product }: Props): React.MixedElement {
  const productErrors = useAppSelector(state =>
    selectOneProductErrors(state, {
      productId: product.id,
    }),
  );

  const label = <Fqdn>{product.label || ''}</Fqdn>;

  return (
    <ProductItem
      key={`${product.id}-row`}
      hasTaxes={product.hasTaxes}
      priceBeforeTaxes={
        product.isWorking ? undefined : product.total?.before_taxes
      }
      productId={product.id}
      label={label}
      errors={productErrors}
    />
  );
}
